import { environment } from '../../../environments/environment';

export class BackendServerConf {
  public static baseUrlBackend = `${environment.apiUrl}`;
  public static baseUrlBackendPrincipal = "https://apisimlait.mascosolutions.com/api";
  // public static baseUrlBackend = "http://192.168.1.12:8000";
  // public static serverUeadUploadDirFileUrl = "https://bdsp.massolutions.pro/upload-dir/";
  // public static serverUeadUploadDirFileUrl = "api/upload/nouveau/";
}
